import React from 'react';
import { Form, Input, Button, InputNumber, Select } from "antd";
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import { UserService } from '../../../Services/Manage/UserService';

const AddService = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();

    const handleFinish = async (values) => {
        try {

            const user = await UserService.getOmeUser();
            const payload = {
                ...values,
                unit_price: values.unit_price ? Number(values.unit_price) : 0,
                added_by: user.uid,
                };

            if (initialValues?.id) {
            

                const req = await ServicetypeService.updateServices(payload, initialValues.id,);
        

                if (req.status) {
                    message.success(req.message)
                    onSubmit(values);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }

            } else {
                const req = await ServicetypeService.createServices(payload);
        
                if (req.status) {
                    message.success(req.message)
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }
            }


        } catch (error) {
            console.error("Service operation failed:", error);
        }
    };

    return (
        <>{messagecontxt}
            <Form
                form={form}
                layout="vertical"
                initialValues={initialValues || {}}
                onFinish={handleFinish}
            >
                <Form.Item
                    name="service_name"
                    label="Service Name"
                    rules={[{ required: true, message: 'Please enter service name' }]}
                >
                    <Input size="large" />
                </Form.Item>

                <Form.Item
                    name="service_code"
                    label="Service Code"
                    rules={[{ required: true, message: 'Please enter service code' }]}
                >
                    <Input size="large" />
                </Form.Item>
                <Form.Item
                label="Unit Price"
                name="unit_price"
                >
                <InputNumber
                    size="large"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Enter unit price"
                />
                </Form.Item>
                <Form.Item
                    name="status"
                    label="Status"
                    initialValue="Active"
                >
                    <Select
                        size="large"
                        options={[
                            { label: "Active", value: "Active" },
                            { label: "Inactive", value: "Inactive" }
                        ]}
                    />
                </Form.Item>

                <Form.Item name="note" label="Note">
                    <Input.TextArea rows={3} size="large" />
                </Form.Item>

                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" size="large">
                        {initialValues?.id ? 'Update' : 'Add'}
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default AddService;
